var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isAdmin)?_c('manager-vacation-tracker',{attrs:{"manager-id":_vm.managerId}}):[_c('staff-vacation-tracker',{attrs:{"staff-id":_vm.staffId}}),_vm._v(" "),(_vm.isParent)?_c('manager-vacation-tracker',{attrs:{"manager-id":_vm.managerId}}):_vm._e()]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }